<template>
  <div :class="classes">
    <slot></slot>
  </div>
</template>
<script>
  import { findComponentsDownward } from '../../utils/assist'
  import Emitter from '../../mixins/emitter'
  const PREFIX_RADIO_GROUP_CLASS = 'radio-group'
  let nameIndex = 0

  export default {
    name: 'TRadioGroup',
    mixins: [ Emitter ],
    props: {
      value: {
        type: [ String, Number ],
        default: ''
      },
      size: {
        type: String,
        default: '',
        validator (value) {
          return ['lg', 'sm', ''].includes(value)
        }
      },
      type: {
        type: String,
        default: '',
        validator (value) {
          return [ 'button', '' ].includes(value)
        }
      },
      vertical: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        gName: '',
        currentValue: this.value,
        childrens: []
      }
    },
    computed: {
      groupName() {
        return this.gName
      },
      classes () {
        return [
          `${PREFIX_RADIO_GROUP_CLASS}`,
          {
            [`${PREFIX_RADIO_GROUP_CLASS}--${this.size}`]: !!this.size,
            [`${PREFIX_RADIO_GROUP_CLASS}-${this.type}`]: !!this.type,
            [`${PREFIX_RADIO_GROUP_CLASS}-inline`]: !this.vertical
          }
        ]
      }
    },
    mounted () {
      this.updateValue()
    },
    created() {
      this.gName = `rgrp${nameIndex++}`
    },
    methods: {
      updateValue () {
        const value = this.value
        this.childrens = findComponentsDownward(this, 'TRadio')
        if (this.childrens) {
          this.childrens.forEach(child => {
            child.currentValue = value === child.label
            child.group = true
          })
        }
      },
      _change (data) {
        this.currentValue = data.value
        this.$emit('input', data.value)
        this.$emit('on-change', data.value)
        this.dispatch('TFormItem', 'on-form-change', data.value)
      }
    },
    watch: {
      value () {
        this.updateValue()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// radio-group.vue?06d58da3